module.exports = __webpack_public_path__ + "static/media/ic_pin_gris.a1ddab19.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_pin_gris.webp
// module id = 165
// module chunks = 1